import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import Banner from "./Banner";
import { Link } from "react-router-dom";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <Banner />

      <header
        className={`fixed left-0 right-0 w-full z-[99] transition-all duration-300 
          flex flex-wrap text-gray-800
          ${isScrolled ? "top-0 backdrop-blur-md bg-white/70 shadow-md" : "top-12 bg-transparent"}`}
      >
        <nav className="relative max-w-[80rem] w-full mx-auto px-4 sm:px-6 lg:px-8 py-2">
          <div className="flex items-center justify-between w-full">
            <Link
              to="/"
              className="flex-none font-semibold text-xl focus:outline-none focus:opacity-80"
            >
              <img src={logo} alt="logo" className="w-48 sm:w-72 z-[99]" />
            </Link>

            <button
              className="md:hidden p-2 focus:outline-none"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            {/* Improved Sidebar */}
            <div
              className={`fixed inset-0 md:inset-auto md:relative h-screen md:h-auto w-full md:w-auto 
                bg-gray-900 md:bg-transparent text-white md:text-gray-800 transform transition-transform 
                duration-300 ease-in-out z-[100]
                ${isMenuOpen ? "translate-x-0" : "translate-x-full md:translate-x-0"}
                md:flex md:items-center md:justify-center`}
            >
              {/* Close Button */}
              <button
                className="md:hidden absolute top-4 right-4 p-2 text-white hover:text-gray-300 
                  focus:outline-none bg-gray-800 rounded-full"
                onClick={toggleMenu}
                aria-label="Close menu"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              {/* Menu Items */}
              <div className="flex flex-col space-y-4 md:space-y-0 md:flex-row md:items-center md:space-x-3 h-full md:h-auto 
                pt-24 md:pt-0 px-6 md:px-0">
                <Link
                  to="/"
                  className="p-4 md:p-2 flex items-center text-xl md:text-sm hover:bg-gray-800 
                    md:hover:bg-transparent md:hover:text-gray-600 border-b md:border-0 
                    border-gray-800 transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
                <Link
                  to="/about"
                  className="p-4 md:p-2 flex items-center text-xl md:text-sm hover:bg-gray-800 
                    md:hover:bg-transparent md:hover:text-gray-600 border-b md:border-0 
                    border-gray-800 transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  About
                </Link>
                <Link
                  to="/services"
                  className="p-4 md:p-2 flex items-center text-xl md:text-sm hover:bg-gray-800 
                    md:hover:bg-transparent md:hover:text-gray-600 border-b md:border-0 
                    border-gray-800 transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Services
                </Link>
                <Link
                  to="/careers"
                  className="p-4 md:p-2 flex items-center text-xl md:text-sm hover:bg-gray-800 
                    md:hover:bg-transparent md:hover:text-gray-600 border-b md:border-0 
                    border-gray-800 transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Portfolio
                </Link>

                <div className="border-t-0 md:border-l border-gray-400 h-4 pt-8 md:pt-0 flex items-center">
                  <Link
                    to="/contact"
                    className="px-4 md:px-4 flex items-center text-xl md:text-sm hover:bg-gray-800 
                      md:hover:bg-transparent md:hover:text-gray-600 transition-colors duration-200"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <svg
                      className="shrink-0 size-5 md:size-4 me-3 md:me-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    Consultation
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Header;